import * as React from 'react';

const FileIcon = ({fillColor = '#2d2756'}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={25}
    height={30}
    viewBox="0 0 68.25 91">
    <path
      d="M39.813 24.172V0H4.266A4.255 4.255 0 0 0 0 4.266v82.468A4.255 4.255 0 0 0 4.266 91h59.718a4.255 4.255 0 0 0 4.266-4.266v-58.3H44.078a4.278 4.278 0 0 1-4.265-4.262Zm28.437-2.506v1.084H45.5V0h1.084a4.262 4.262 0 0 1 3.021 1.244l17.4 17.418a4.252 4.252 0 0 1 1.245 3.004Z"
      style={{
        fill: fillColor,
      }}
    />
  </svg>
);

export default FileIcon;
